import { ModalCustom } from '$src/components/Modal';
import PropTypes from 'prop-types';
import useStores from '$src/hooks/useStores';
import { Link } from '@amzn/ring-react-components/csr/components/Link';
import { redirectToURL } from '$src/utils/redirect';
import { HOW_TO_USE_GEOFENCE_URL, SETTINGS_GEOFENCE_URL } from '$src/constants/urls';
import { GeofencingIcon } from '@ring-icons';

import './index.less';

export default function GeofenceDialog({ showModal, toggleGeofenceDialog, ...rest }) {
  const { sessionStore } = useStores();
  const { isMobile } = sessionStore;

  const handleCancel = () => {
    sessionStorage.setItem('geofence-dialog-closed', true);
  };

  const handleOk = () => {
    if (isMobile) {
      redirectToURL(SETTINGS_GEOFENCE_URL);
    } else {
      sessionStorage.setItem('geofence-dialog-closed', true);
      toggleGeofenceDialog();
    }
  };

  return (
    <ModalCustom
      {...rest}
      title="Geofencing"
      data-testid="geofencing-dialog"
      cancelOnX
      setModalVisible={toggleGeofenceDialog}
      contentTitle={
        <>
          <GeofencingIcon width="42px" />
          <h1>How Virtual Security Guard works with Geofence.</h1>
        </>
      }
      width="650px"
      className="geofence-dialog modal-wrapper"
      contentMessage={
        <>
          <p>
            Geofence is a virtual boundary you can draw around your Location that allows you to receive reminders to arm/disarm your system when you
            leave/enter your boundary, or automatically Snooze motion events when you enter your property. Geofence works with Virtual Security Guard
            Snooze to pause motion events when you enter your boundary, helping to prevent unnecessary events and contacts from guards.
          </p>
          <p>
            When Snooze is enabled for Geofence and Virtual Security Guard is on, we will automatically pause monitoring until your chosen Snooze
            duration expires.
          </p>
          <p>
            {isMobile ? 'Tap below to set up your Geofence. ' : 'You can set up your Geofence in the Ring app. '}
            <Link color="primary" link={HOW_TO_USE_GEOFENCE_URL} type="external">
              Learn more here
            </Link>
          </p>
        </>
      }
      visible={showModal}
      handleOk={handleOk}
      okText={isMobile ? 'Set up Geofence' : 'Got it'}
      cancelText="Got it"
      handleCancel={handleCancel}
    />
  );
}

GeofenceDialog.propTypes = {
  showModal: PropTypes.bool.isRequired,
  toggleGeofenceDialog: PropTypes.func,
};
